import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPercent, faTruckFast, faReceipt } from '@fortawesome/free-solid-svg-icons';

import './Repair.scss';

import air from './../assets/images/air.png';

const Repair = () => {
  return (
    <>
      <div className='repair__container'>
        <div className='top__repair'>
          <div className='img__repair'>
            <img className='picture__of' src={air} alt='air_cond'></img>
          </div>
          <div className='text__repair'>
            <h3 className='title__repair'>
              Repair of Air Conditioners and Commercial Refrigeration Equipment
            </h3>
            <div className='icons__repair'>
              <div className='repair__item'>
                <div className='repair__icon__item'>
                  <FontAwesomeIcon icon={faPercent} className="ic" />
                  <p className='repair__item__text'>New customer discounts</p>
                </div>
              </div>
              <div className='repair__item'>
                <div className='repair__icon__item'>
                  <FontAwesomeIcon icon={faTruckFast} className="ic" />
                  <p className='repair__item__text'>Free <br></br> checkout</p>
                </div>
              </div>
              <div className='repair__item'>
                <div className='repair__icon__item'>
                  <FontAwesomeIcon icon={faReceipt} className="ic" />
                  <p className='repair__item__text'>Payment after completion of work</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='middle__repair'>
          <div className='repair__solve'>
            <h3 className='middle__title'>
              Air conditioner problems we solve
            </h3>
            <p className='middle__content'>
              Our masters are ready to perform air conditioner repair at home without weekends. We also professionally perform on-site preventive maintenance of air conditioner and split-systems. All masters are highly qualified and have many years of experience in repairing air conditioners. All types of work are performed at home, in rare cases - in the service.
            </p>
          </div>
          <div className='repair__box__items'>
            <div className='middle__item'>
              <h4 className='middle__num__repair'>
                01
              </h4>
              <p className='middle__desc__repair__top'>
                Unpleasant smell
              </p>
              <p className='middle__desc__repair__bottom'>
                Unpleasant odor from the air conditioner often appears due to dirty filters, light freon leakage, oxidation of contacts and others
              </p>
            </div>
            <div className='middle__item'>
              <h4 className='middle__num__repair'>
                02
              </h4>
              <p className='middle__desc__repair__top'>
              It doesn't blow well
              </p>
              <p className='middle__desc__repair__bottom'>
              The air conditioner may not blow well due to dirty filters, a problem with the compressor, the outdoor unit
              </p>
            </div>
            <div className='middle__item'>
              <h4 className='middle__num__repair'>
                03
              </h4>
              <p className='middle__desc__repair__top'>
              Whistling
              </p>
              <p className='middle__desc__repair__bottom'>
              The air conditioner may whistle due to dirty filters, broken plastic structure, a problem with the throttle system</p>
            </div>
            <div className='middle__item'>
              <h4 className='middle__num__repair'>
                04
              </h4>
              <p className='middle__desc__repair__top'>
              Water leaks
              </p>
              <p className='middle__desc__repair__bottom'>
                Most often water leaks from the air conditioner because of the drain filter system, clogged pipes do not allow water to reach the outdoor unit</p>
            </div>
            <div className='middle__item'>
              <h4 className='middle__num__repair'>
                05
              </h4>
              <p className='middle__desc__repair__top'>
              Doesn't turn on
              </p>
              <p className='middle__desc__repair__bottom'>
              The air conditioner may not turn on due to hundreds of reasons, the best solution is to call a craftsman to diagnose and establish the problem</p>
            </div>
            <div className='middle__item'>
              <h4 className='middle__num__repair'>
                06
              </h4>
              <p className='middle__desc__repair__top'>
              It doesn't warm
              </p>
              <p className='middle__desc__repair__bottom'>
              If the air conditioner stops heating, the heating module board is probably broken, or the throttle system filters are clogged</p>
            </div>
            <div className='middle__item'>
              <h4 className='middle__num__repair'>
                07
              </h4>
              <p className='middle__desc__repair__top'>
              It doesn't cool
              </p>
              <p className='middle__desc__repair__bottom'>
              If the air conditioner stopped cooling it is most likely due to lack of freon, clogged filters, dirt in the drain system</p>
            </div>
            <div className='middle__item'>
              <h4 className='middle__num__repair'>
                08
              </h4>
              <p className='middle__desc__repair__top'>
              It's noisy
              </p>
              <p className='middle__desc__repair__bottom'>
              Noisy air conditioner can be caused by mechanical breakdown or compressor failure, the best option is to call a master to diagnose the equipment</p>
            </div>
            <div className='middle__item'>
              <h4 className='middle__num__repair'>
                09
              </h4>
              <p className='middle__desc__repair__top'>
              Compressor doesn't turn on
              </p>
              <p className='middle__desc__repair__bottom'>
              Actual compressor outages are due to a malfunction of the compressor itself. The best option is to have the compressor diagnosed</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Repair;